export const ka = {
  brand: { name: "SmartPaw", tagline: "პირადი კაბინეტი" },
  language: { ka: "ქართული", en: "English", short_ka: "KA", short_en: "EN", toggle_aria: "ენის შეცვლა" },
  nav: {
    dashboard: "მთავარი", subscription: "გამოწერა", subscriptions: "ჩემი გამოწერები",
    catalogue: "პარტნიორი ბრენდები", offers: "სპეც. შეთავაზებები", pets: "ცხოველები",
    calendar: "კალენდარი",
    orders: "შეკვეთები", addresses: "მისამართები", profile: "პროფილი",
    requests: "ჩემი მოთხოვნები",
    deliveries: "ჩემი მიწოდებები",
    payments: "გადახდები",
    notifications: "შეტყობინებები", logout: "გამოსვლა", account: "ანგარიში"
  },
  auth: {
    sign_in: "შესვლა", sign_up: "რეგისტრაცია",
    email: "ელფოსტა", password: "პაროლი", password_repeat: "გაიმეორე პაროლი", name: "სახელი",
    welcome_back: "მოგისალმებით დაბრუნდით",
    create_account: "შექმენი ანგარიში",
    login_subtitle: "მართე შენი SmartPaw კაბინეტი",
    register_subtitle: "ახალი მომხმარებლის რეგისტრაცია",
    continue_with_google: "გაგრძელე Google-ით",
    or_continue_with: "ან გაგრძელე ელფოსტით",
    forgot_password: "დაგავიწყდებია?",
    no_account: "არგაქვთ ანგარიში?", have_account: "გაქვთ ანგარიში?",
    register_now: "დარეგისტრირდი", sign_in_now: "შედით",
    submitting: "დამუშავება..."
  },
  wizard: {
    step: "ნაბიჯი {n} / {total}",
    next: "შემდეგი",
    back: "უკან",
    skip: "გამოტოვება",
    finish: "დასრულება და დარეგისტრირება",
    step1_title: "შექმენი ანგარიში",
    step1_subtitle: "შენი სახელი, ელფოსტა და პაროლი",
    step2_title: "საკონტაქტო ინფორმაცია",
    step2_subtitle: "სად მოვიტანოთ შენი ყუთები?",
    step3_title: "შენი ცხოველი",
    step3_subtitle: "მოგვიყევი შენი ცხოველის შესახებ (არასავალდებულო)",
    step4_title: "შენი პირველი გამოწერა",
    step4_subtitle: "აარჩიე პროდუქტები და მიწოდების სიხშირე — შეგიძლია მოგვიანებით 3-მდე გამოწერა გქონდეს",
    add_subscription: "დაამატე გამოწერა",
    remove_subscription: "წაშლა",
    subscription_n: "გამოწერა #{n}",
    first_delivery: "პირველი მიწოდების თარიღი",
    pick_products: "აარჩიე პროდუქტები",
    label_placeholder: "სახელი (მაგ: „ბიბოს საკვები“)",
    pet_optional: "შეგიძლია გამოტოვო და მოგვიანებით დაამატო",
    sub_optional: "შეგიძლია გამოტოვო და მოგვიანებით დაამატო კაბინეტიდან",
    no_products_yet: "ჯერ პროდუქტი არ არჩეულა.",
    err_name_required: "სახელი სავალდებულოა",
    err_email_required: "ელფოსტა სავალდებულოა",
    err_password_short: "პაროლი უნდა იყოს მინიმუმ 6 სიმბოლო",
    err_password_mismatch: "პაროლები არ ემთხვევა",
    err_phone_required: "გთხოვ შეიყვანო ვალიდური ტელეფონის ნომერი",
    phone_hint: "გვჭირდება მხოლოდ მიწოდების შესახებ შეტყობინებებისა და SmartPaw ექსპერტის კონსულტაციისთვის."
  },
  dashboard: {
    title: "მოგისალმებით",
    subtitle: "იხილე შენი მომდევნო მიწოდებები და ნებისმიერ შეცვალე წესი.",
    next_delivery: "შემდეგი მიწოდება",
    no_subscription: "აქტიური გამოწერა არ გაქვთ",
    start_now: "დაიწყე გამოწერა",
    in_box: "ყუთშია", edit_upcoming: "გრაფიკის რედაქტირება",
    pause: "დაპაუზება", resume: "განახლება",
    quick_pets: "ჩემი ცხოველები",
    quick_address: "ნაგულისხბი მისამართი",
    recent_orders: "ბოლო შეკვეთები",
    see_all: "ნახე ყველა",
    add_pet: "დაამატე ცხოველი", add_address: "დაამატე მისამართი",
    no_pets: "ცხოველები განათავსებლად დაამატე.",
    no_addresses: "დაამატე მისამართისთვის.",
    no_orders: "ბოლო შეკვეთები არ გაქვთ.",
    countdown_days: "დღე", countdown_hours: "საათი", countdown_minutes: "წუთი",
    paused_label: "პაუზირებული", cancelled_label: "გაუქმებული",
    your_subscriptions: "ჩემი გამოწერები",
    offers_strip_title: "სპეციალური შეთავაზებები",
    offers_view_all: "ყველა შეთავაზება"
  },
  subscription: {
    title: "ჩემი გამოწერები",
    subtitle: "მართე სიხშირე, პროდუქტები და მისამართები — შენ შეგიძლია 3-მდე გამოწერა გქონდეს.",
    add_new: "დაამატე გამოწერა",
    max_reached: "3 აქტიური გამოწერის ლიმიტი მიღწეულია.",
    delete: "წაშლა",
    delete_confirm_title: "წაშალოთ ეს გამოწერა?",
    delete_confirm_text: "ეს მოქმედება შეუქცევადია.",
    deleted_toast: "გამოწერა წაიშალა",
    name_label: "გამოწერის სახელი",
    frequency: "მიწოდების სიხშირე",
    weekly: "ყოველკვირა", biweekly: "ორ კვირაში ერთხელ", monthly: "თვეში ერთხელ",
    delivery_address: "მიტანის მისამართი",
    next_delivery: "შემდეგი მიწოდება",
    change_date: "შეცვალე თარიღი",
    items: "პროდუქტები", qty: "რაოდ.",
    add_more: "დაამატე პროდუქტები",
    save: "შენახვა",
    pause: "დაპაუზება", resume: "განახლება",
    cancel: "გაუქმება",
    cancel_confirm_title: "გაუქმდება გამოწერა?",
    cancel_confirm_text: "შეგიძლიათ მოგვიანებით განახოთ ნებისმიერ დროს.",
    cancel_confirm_ok: "დიახ, გაუქმდება",
    cancel_back: "უკან, შენახული",
    saved_toast: "გამოწერა შენახულია",
    paused_toast: "გამოწერა დაპაუზდა",
    resumed_toast: "გამოწერა განახლდა",
    cancelled_toast: "გამოწერა გაუქმდა",
    no_items: "ჩამატეთ პროდუქტები კატალოგიდან.",
    remove: "წაშლა",
    no_address_warning: "წინასწარ დაამატე მისამართი.",
    status: { active: "აქტიური", paused: "პაუზირებული", cancelled: "გაუქმებული" }
  },
  catalogue: {
    title: "კატალოგი", subtitle: "დაამატე პროდუქტები შემდეგ ჭდელღდელი მიწოდებაში.",
    all: "ყველა", food: "საკვები", hygiene: "ჰიგიენა", vitamins: "ვიტამინები და დანამატები",
    search_placeholder: "ძებნა კატალოგიდან...",
    add_to_upcoming: "დაამატე", in_subscription: "გამოწერაში არის",
    added_toast: "დაემატა შემდეგ მიწოდებაში",
    no_results: "პროდუქტები ვერ მოიძებნა.",
    suitable: { dog: "ძაღლი", cat: "კატა", both: "ძაღლი / კატა" },
    choose_subscription: "აარჩიე გამოწერა",
    choose_subscription_desc: "მონიშნე რომელ გამოწერაში დაამატო ეს პროდუქტი.",
    add_button: "დაამატე"
  },
  offers: {
    title: "სპეციალური შეთავაზებები",
    subtitle: "ექსკლუზიური ფასდაკლებები და ფასიანი კომპლექტები შენი გამოწერებისთვის.",
    add_to_box: "დაამატე ჩემს ყუთში",
    add_to_subscription: "აარჩიე გამოწერა შეთავაზებისთვის",
    applied_toast: "შეთავაზება დაემატა",
    includes: "შემავალი:",
    no_offers: "ამჟამად აქტიური შეთავაზებები არ არის.",
    expires: "იწურება", saves: "დაზოგე"
  },
  pets: {
    title: "ჩემი ცხოველები",
    subtitle: "დაამატე ცხოველის პროფილი ინდივიდუალური რეკომენდაციისთვის.",
    add: "დაამატე ცხოველი", edit: "შეცვლა", delete: "წაშლა",
    name: "სახელი", species: "სახეობა", dog: "ძაღლი", cat: "კატა",
    breed: "ჯიში", birth_date: "დაბადების თარიღი",
    weight_kg: "წონა (კგ)", photo: "ფოტო",
    photo_url: "ფოტო URL",
    approx_age: "სავარაუდო ასაკი (თუ თარიღი არ იცი)",
    age_label: "ასაკი",
    birth_certificate: "დაბადების მოწმობა (PDF/JPG, არასავალდებულო)",
    dietary_notes: "დიეტოლოგიური შენიშვნები",
    save: "შენახვა", cancel: "გაუქმება",
    saved_toast: "ცხოველის პროფილი შენახულია",
    deleted_toast: "ცხოველი წაიშალა",
    confirm_delete: "წავშალოთ ეს ცხოველი?",
    no_pets: "ცხოველები ჯერ არ გაქვთ დამატებული.",
    vet_section: "ვეტერინარის კონტაქტი (არასავალდებულო)",
    vet_hint: "ჩვენ მას გამოვაჩენთ კალენდრის ყველა ვეტერინარის ვიზიტზე.",
    vet_name: "ვეტერინარის სახელი",
    vet_clinic: "კლინიკა",
    vet_phone: "ტელეფონი",
    vet_email: "ელფოსტა",
    vet_address: "მისამართი",
    vet_notes: "შენიშვნები"
  },
  photo: {
    upload: "ფოტოს ატვირთვა",
    take_photo: "ფოტოს გადაღება",
    drop_or_click: "გადმოიტანე ფოტო ან დააწკაპუნე ასარჩევად",
    camera_open: "კამერის გახსნა",
    capture: "გადაღება",
    retake: "კიდევ ერთხელ",
    use_photo: "გამოყენება",
    close: "დახურვა",
    camera_error: "კამერა ვერ ჩაირთო. გადაამოწმე ბრაუზერის ნებართვა."
  },
  file: { upload_hint: "გადმოიტანე ფაილი ან დააწკაპუნე ასარჩევად (JPG/PNG/PDF)" },
  quiz: {
    title: "მოკლე ანკეტა",
    subtitle: "არასავალდებულო ანკეტა — დაგვეხმარება შესაბამისი პროდუქტების შეთავაზებაში.",
    open_button: "შეავსე ანკეტა",
    completed: "ანკეტა შევსებულია",
    saved_toast: "ანკეტა შენახულია",
    save: "ანკეტის შენახვა",
    q1: "რამდენ დროს ატარებთ თქვენს ცხოველთან დღეში?",
    time_lt1: "1 საათზე ნაკლები", time_1to3: "1–3 საათი", time_3to6: "3–6 საათი", time_gt6: "6+ საათი",
    q2: "რამდენი შინაური ცხოველი გყავთ სახლში?",
    q3: "კვებავთ მხოლოდ მშრალი საკვებით თუ ერთვის სველი საკვები/ხემსები?",
    food_dry_only: "მხოლოდ მშრალი", food_dry_wet: "მშრალი + სველი",
    food_dry_snacks: "მშრალი + ხემსები", food_dry_wet_snacks: "მშრალი + სველი + ხემსები",
    q4: "რამდენად ხშირად აძლევთ ცხოველს ხემსებს?",
    snack_never: "არასოდეს", snack_weekly: "კვირაში რამდენჯერმე",
    snack_daily: "ყოველდღე", snack_multiple_daily: "დღეში რამდენჯერმე",
    q5: "აქვს თუ არა თქვენს ცხოველს ალერგია?",
    allergies_no: "არა", allergies_yes: "კი", allergies_unknown: "არ ვიცი",
    allergies_placeholder: "მიუთითეთ რომელ ინგრედიენტებზე",
    q6: "რომელი მშრალი საკვების გემო ურჩევნია თქვენს ცხოველს?",
    flavor_chicken: "ქათამი", flavor_beef: "საქონლის ხორცი", flavor_fish: "თევზი",
    flavor_lamb: "ცხვარი", flavor_turkey: "ინდაური", flavor_mixed: "შერეული",
    flavor_none: "უპირატესობა არ აქვს"
  },
  payment: {
    title: "გადახდის მეთოდი",
    bank_transfer: "საბანკო გადარიცხვა",
    cash_on_delivery: "ნაღდი კურიერთან",
    method_label: "გადახდა"
  },
  addresses: {
    title: "მისამართები", subtitle: "მართე მიტანის მისამართები და პირველადი წყარო.",
    add: "დაამატე მისამართი", label: "ეჭიყვიანი",
    recipient: "მიმღები", phone: "ტელეფონი", city: "ქალაქი",
    district: "უბანი", street: "ქუჩა", building: "შენობა",
    apartment: "ბინა", postal_code: "საფოსტო ინდექსი",
    notes: "შენიშვნები", default: "ნაგულისხები",
    set_default: "დააყე ნაგულისხებად",
    edit: "შეცვლა", delete: "წაშლა", save: "შენახვა", cancel: "გაუქმება",
    saved_toast: "მისამართი შენახულია", deleted_toast: "მისამართი წაიშალა",
    no_addresses: "ჯერ არცერთი მისამართი არ გაქვთ."
  },
  orders: {
    title: "შეკვეთები", subtitle: "იხილე მიწოდების ისტორია და ინვოისები.",
    invoice: "ინვოისი", date: "თარიღი", items: "პროდუქტები",
    total: "ჯამური", status: "სტატუსი", view: "ნახვა",
    delivered: "მიტანილი", processing: "მზაddებაში",
    scheduled: "დაგეგმილი", cancelled: "გაუქმებული",
    no_orders: "ჯერ არცერთი შეკვეთა არ გქონიათ.",
    subtotal: "ქვეჯამური", delivery_fee: "მიტანის ღირებულება",
    free: "უფასო", delivery_to: "მიტანა:", qty_short: "x"
  },
  requests: {
    title: "ჩემი მოთხოვნები",
    subtitle: "თვალი ადევნე იმ პროდუქტების სტატუსს, რომელთა მოძიებაც ჩვენგან მოითხოვე.",
    new_request: "მოითხოვე პროდუქტი",
    empty: "ჯერ არცერთი პროდუქტი არ მოგითხოვია. თუ საჭირო პროდუქტი ჩვენს კატალოგში არ არის, მოგვწერე და მოვიძიებთ შენთვის.",
    view: "ნახვა",
    no_details: "დამატებითი ინფორმაცია არ არის",
    qty_short: "x",
    request_id: "მოთხოვნის ID",
    admin_note: "SmartPaw-ის შენიშვნა",
    contact_hint: "გიპასუხებთ:",
    status: {
      pending: "განხილვაში",
      sourced: "მოძიებულია — შეკვეთისთვის მზადაა",
      ordered: "შეკვეთილია",
      declined: "ვერ მოვიძიეთ"
    },
    col: {
      status: "სტატუსი",
      submitted: "გაგზავნილია",
      brand: "ბრენდი",
      size: "ზომა / შეფუთვა",
      quantity: "რაოდენობა",
      notes: "შენიშვნები",
      photo: "ფოტო"
    }
  },
  profile: {
    title: "პროფილი", subtitle: "შეჭიდეთ თქვენი ანგარიშის ინფორმაცია.",
    name: "სახელი", email: "ელფოსტა", phone: "ტელეფონი",
    member_since: "წევრია თარიღიდან", save: "შენახვა",
    saved_toast: "პროფილი განახლდა", sign_in_method: "შესვლის მეთოდი"
  },
  notifications: {
    title: "შეტყობინებები", subtitle: "აკონტროლე რა და როდის გაიცნობოთ.",
    channels: "არხები", types: "ტიპები",
    email_enabled: "ელფოსტა", sms_enabled: "SMS", whatsapp_enabled: "WhatsApp",
    delivery_reminders: "მიწოდების შეხსენებები",
    daily_digest_enabled: "დღიური ცხოველის ამოცანების შეჯამება (8:00 თბილისის დროით)",
    low_stock_alerts: "მარაგის სიგნალები",
    marketing: "სიახლეები და ოფერები",
    saved_toast: "პრეფერენცები შენახულია"
  },
  common: {
    loading: "იტვირთება...", saving: "ინახება...",
    retry: "ხელახლა ცდა", error_generic: "რაღაც შეცდომა. სცადეთ თავიდან.",
    confirm: "დადასტურება", close: "დახურვა",
    currency: "ლ", next_box_in: "შემდეგი ყუთი მოვა:",
    optional: "არასავალდებულო", required: "სავალდებულო"
  },
  calendar: {
    title: "ცხოველის მოვლის კალენდარი",
    subtitle: "დაგეგმე მედიკამენტები, მოვლა, ვეტერინარის ვიზიტები, საკვების მიწოდება — ერთ ადგილზე.",
    add_event: "ღონისძიების დამატება",
    new_event: "ახალი ღონისძიება",
    edit_event: "ღონისძიების რედაქტირება",
    today: "დღეს",
    view_month: "თვე",
    view_list: "მომავალი",
    all_pets: "ყველა ცხოველი",
    all_categories: "ყველა კატეგორია",
    no_pet: "კონკრეტული ცხოველის გარეშე",
    field_title: "სათაური",
    field_category: "კატეგორია",
    field_pet: "ცხოველი",
    field_when: "როდის",
    field_duration: "ხანგრძლივობა (წთ)",
    field_repeat: "გამეორება",
    field_until: "გამეორება სანამ (არასავალდებულო)",
    field_notes: "შენიშვნები",
    field_remind_when: "გაგზავნე",
    reminders: "შეხსენებები",
    remind_none: "შეხსენების გარეშე",
    remind_1h: "1 საათით ადრე",
    remind_24h: "24 საათით ადრე",
    via_email: "ელფოსტა",
    via_whatsapp: "WhatsApp",
    whatsapp_pending: "მალე",
    repeat_none: "არ მეორდება",
    repeat_daily: "ყოველდღე",
    repeat_weekly: "ყოველკვირა",
    repeat_monthly: "ყოველთვე",
    repeat_yearly: "ყოველწლიურად",
    title_placeholder: "მაგ. გულის ჭიის აბი",
    notes_placeholder: "დოზა, ვეტერინარის სახელი და ა.შ.",
    title_required: "სათაური აუცილებელია",
    confirm_delete: "წავშალოთ ეს ღონისძიება?",
    event_created: "ღონისძიება დაემატა",
    event_updated: "ღონისძიება განახლდა",
    event_deleted: "ღონისძიება წაიშალა",
    marked_done: "შესრულებულად მონიშნა",
    read_only_event: "ეს ღონისძიება ავტომატურად შეიქმნა გამოწერიდან და ვერ რედაქტირდება.",
    empty_upcoming: "მომავალი ღონისძიებები არ არის. დაამატე პირველი.",
    cancel: "გაუქმება",
    save: "ცვლილების შენახვა",
    create: "ღონისძიების დამატება",
    delete: "წაშლა",
    export_ics: ".ics",
    ics_downloaded: "კალენდრის ფაილი ჩამოიტვირთა — დააიმპორტე Google / Apple Calendar-ში.",
    auto: "ავტო",
    dashboard_widget_title: "მომავალი ცხოველის ამოცანები",
    dashboard_widget_view_all: "კალენდრის ნახვა",
    dashboard_widget_empty: "მომავალი ამოცანები არ არის. დაამატე შეხსენება.",
    use_template: "შაბლონის გამოყენება",
    tpl_picker_title: "მზა გრაფიკები",
    tpl_picker_subtitle: "დააყენე სრული მოვლის გრაფიკი ერთი დაჭერით — WSAVA/AAHA საერთაშორისო სტანდარტებზე დაფუძნებული.",
    tpl_events_count: "ღონისძიება",
    tpl_for_dog: "ძაღლები",
    tpl_for_cat: "კატები",
    tpl_back: "უკან",
    tpl_apply: "დაამატე {count} ღონისძიება",
    tpl_anchor_required: "გთხოვ აირჩიე თარიღი",
    tpl_anchor_hint_birth: "ღონისძიებები გამოითვლება ამ თარიღთან მიმართებაში (მაგ. ვაქცინა მე-8 კვირას).",
    tpl_anchor_hint_start: "ღონისძიებები ამ თარიღიდან დაიწყება.",
    tpl_no_matching_pet: "ეს შაბლონი სხვა სახეობისთვისაა შექმნილი.",
    tpl_reminders_default: "შეხსენებები ნაგულისხმევად დაყენდება 24სთ-ით ადრე ელფოსტით — შემდეგ შეცვალე საჭიროებისამებრ.",
    tpl_created: "კალენდარს დაემატა {count} ღონისძიება",
    stat_streak: "უწყვეტი დროული შესრულება",
    stat_done: "შესრულებული ამოცანები",
    stat_rate: "შესრულების მაჩვენებელი",
    vet_contact: "ვეტერინარის კონტაქტი",
    attachments: "მიმაგრებები",
    attach_upload: "ქვითრის / ფოტოს მიმაგრება",
    attach_hint: "სურათები ან PDF ქვითრები, 6 მბ-მდე.",
    attach_added: "ფაილი მიმაგრდა",
    attach_removed: "მიმაგრება წაიშალა"
  },
  phoneGate: {
    title: "კიდევ ერთი ნაბიჯი",
    subtitle: "გჭირდება შენი ტელეფონის ნომერი, რომ მიწოდებებზე და კონსულტაციებზე დაგიკავშირდეთ.",
    field_label: "ტელეფონის ნომერი",
    hint: "ქართული მობილური ნომერი — გამოვიყენებთ მხოლოდ მნიშვნელოვანი შეტყობინებებისთვის.",
    save: "შენახვა და გაგრძელება",
    saved: "მადლობა! ნომერი შენახულია.",
    invalid: "გთხოვ შეიყვანე ვალიდური ქართული ნომერი"
  },
  limbo: {
    pending_admin_review: {
      eyebrow: "რეგისტრაცია მიღებულია",
      title: "მადლობა, {name}! ჩვენ ვამოწმებთ შენს განაცხადს",
      subtitle: "SmartPaw-ის გუნდი ამოწმებს შენს პროფილს და მზადებს კონკრეტულ ფასებსა და მიწოდების გრაფიკს. ჩვეულებრივ ეს იღებს 1 სამუშაო დღემდე — დაგიკავშირდებით WhatsApp-ით ან ელფოსტით."
    },
    pending_customer_confirmation: {
      eyebrow: "გადახედე და დაადასტურე",
      title: "შენი გეგმა მზადაა, {name}",
      subtitle: "ჩვენი გუნდის შენიშვნები, ფასები და მიწოდების გრაფიკი მზადაა. გადახედე ქვემოთ მონაცემებს და დაადასტურე გასააქტიურებლად, ან მოითხოვე ცვლილებები."
    },
    revisions_requested: {
      eyebrow: "ცვლილების მოთხოვნა გაგზავნილია",
      title: "ცვლილების მოთხოვნა მიღებულია",
      subtitle: "SmartPaw-ის გუნდი დაუბრუნდება შენს მოთხოვნას და მალე გაგზავნის განახლებულ გეგმას დასადასტურებლად."
    },
    rejected: {
      eyebrow: "შეთავაზება უარყოფილია",
      title: "მადლობა უკუკავშირისთვის",
      subtitle: "შენი უარყოფა დარეგისტრირდა ჩვენს არქივში. თუ მომავალში დაინტერესდები, გვწერე info@smartpaw.ge."
    },
    admin_notes_title: "შენიშვნები SmartPaw-ის გუნდისგან",
    profile_summary_title: "შენი პროფილის მონაცემები",
    field_name: "სახელი",
    field_email: "ელფოსტა",
    field_phone: "ტელეფონი",
    section_pets: "ცხოველები ({count})",
    section_addresses: "მისამართები ({count})",
    section_subs: "გამოწერები ({count})",
    section_subs_item: "გამოწერა",
    items_short: "პროდუქტი",
    default_badge: "ნაგულისხმევი",
    confirm_button: "დადასტურება და გააქტიურება",
    request_changes_button: "ცვლილების მოთხოვნა",
    reject_button: "შეთავაზების უარყოფა",
    confirm_success: "შესანიშნავია! შენი ანგარიში გააქტიურდა.",
    request_message_required: "გთხოვ შეიყვანე რომელი ცვლილებაა საჭირო",
    request_sent: "შენი მოთხოვნა გაგზავნილია",
    reject_reason_required: "გთხოვ აირჩიე უარყოფის მიზეზი",
    reject_sent: "მადლობა უკუკავშირისთვის. შენი უარყოფა დარეგისტრირდა.",
    request_dialog_title: "რა ცვლილებაა საჭირო?",
    request_dialog_subtitle: "მოგვწერე რომელი დეტალია გასაცვლელი — ფასი, პროდუქტი, მიწოდების სიხშირე, მისამართი ან სხვა.",
    request_dialog_placeholder: "მაგ. გთხოვ შეცვალე გამოწერა ყოველ 2 კვირაში…",
    request_dialog_cancel: "გაუქმება",
    request_dialog_submit: "მოთხოვნის გაგზავნა",
    reject_dialog_title: "შეთავაზების უარყოფა",
    reject_dialog_subtitle: "მოკლედ გვითხარი რატომ. ეს დაგვეხმარება მომავალში უკეთესი შეთავაზების მომზადებაში.",
    reject_dialog_cancel: "გაუქმება",
    reject_dialog_submit: "უარყოფის დადასტურება",
    reject_reason_label: "მიზეზი",
    reject_reason_placeholder: "აირჩიე მიზეზი",
    reject_reason_price_too_high: "ფასი ძალიან მაღალია",
    reject_reason_products_not_suitable: "პროდუქტები არ მაწყობს",
    reject_reason_delivery_schedule_mismatch: "მიწოდების გრაფიკი არ მაწყობს",
    reject_reason_found_alternative: "სხვა ვარიანტი ვიპოვე",
    reject_reason_not_ready_yet: "ჯერ არ ვარ მზად",
    reject_reason_other: "სხვა",
    reject_note_label: "დამატებითი შენიშვნა (არასავალდებულო)",
    reject_note_placeholder: "დამატებითი დეტალები…",
    footer_note: "თუ რამე საკითხია, დაგვიკავშირდი WhatsApp-ით ან ელფოსტით info@smartpaw.ge."
  },
  deliveries: {
    title: "ჩემი მიწოდებები",
    subtitle: "მომავალი მიწოდებები და უკვე ჩაბარებული შეკვეთები",
    empty: "ჯერ მიწოდება არ გაქვს. გამოწერა ააქტიურდება და მიწოდებები გამოჩნდება აქ.",
    upcoming_title: "მომავალი",
    history_title: "ისტორია",
    confirm_reminder: "დადასტურება",
    confirm_received: "ჩავიბარე",
    confirmed_toast: "მადლობა! მიწოდება დადასტურდა. მალე მიიღებ გადახდის ინსტრუქციას.",
    confirmed_badge: "დადასტურებულია",
    delivered_badge: "მიწოდებულია",
    paid: "გადახდილი"
  },
  payments: {
    title: "გადახდები",
    subtitle: "გადახდის ისტორია, გადასახდელი თანხები და ბანკის რეკვიზიტები",
    unpaid_title: "გადასახდელი",
    unpaid_badge: "გადასახდელია",
    bank_title: "სად გადავიხადო",
    bank_name: "ბანკი",
    account_holder: "ბენეფიციარი",
    bank_code: "ბანკის კოდი",
    history_title: "გადახდის ისტორია",
    history_empty: "ჯერ გადახდილი მიწოდება არ გაქვს.",
    paid_badge: "გადახდილი",
    reference_label: "რეკვიზიტი"
  }
};
